import { useEffect, useState } from 'react'
import { string, func, bool } from 'prop-types'
import DatePicker, { registerLocale } from 'react-datepicker'
import fr from 'date-fns/locale/fr'
import en from 'date-fns/locale/en-US'
import Div from '@ui/layout/Div'
import 'react-datepicker/dist/react-datepicker.css'
import Alert from '@ui/elements/Alert'

const DateType = ({
  onChange = () => { },
  disabled = false,
  isRequired = false,
  isInline = false,
  name,
  cssClass,
  value,
  placeholder,
  label,
  help,
  error
}) => {
  const [selectedDate, setSelectedDate] = useState(value ? new Date(value) : false)
  registerLocale('fr', fr)
  registerLocale('en', en)
  if (value && !selectedDate) {
    setSelectedDate(new Date(value))
  }

  const sendDate = date => {
    const formatedDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    onChange(name, formatedDate)
    setSelectedDate(date)
  }

  useEffect(() => {
    setSelectedDate(value ? new Date(value) : false)
  }, [value])

  return (
    <Div cssClass={`field ${cssClass}`}>
      {label && <label className={`label ${isRequired ? 'is-required' : ''}`} htmlFor={`input-${name}`}>{label}</label>}
      <Div cssClass="control">
        <DatePicker dateFormat='dd/MM/yyyy' locale='fr' peekNextMonth showMonthDropdown showYearDropdown dropdownMode="select" selected={selectedDate}
          onChange={date => sendDate(date)} placeholderText={placeholder} disabled={disabled} inline={isInline} id={`input-${name}`} />
      </Div>
      {help && <p className="help">{help}</p>}
      {error && <Alert cssClass='clear' type='is-danger' message={error} />}
    </Div>
  )
}

DateType.propTypes = {
  name: string,
  onChange: func,
  cssClass: string,
  disabled: bool,
  value: string,
  placeholder: string,
  help: string,
  label: string,
  error: string,
  isRequired: bool,
  isInline: bool
}

export default DateType
